module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend-company box-shadow"
  }, [_c('div', {
    staticClass: "recommend-title"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/icon8.png")
    }
  }), _vm._v(" " + _vm._s(_vm.title) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "company-list"
  }, [_vm._l((_vm.list), function(item, index) {
    return [_c('div', {
      staticClass: "company-item",
      on: {
        "click": function($event) {
          return _vm.tonextnew(item.id)
        }
      }
    }, [_c('avatar-view', {
      attrs: {
        "size": 45,
        "name": item.company_name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "company-right"
    }, [_c('div', {
      staticClass: "company-title text-cut1 margin-bottom-4"
    }, [_vm._v(" " + _vm._s(item.company_name))]), _vm._v(" "), _c('div', {
      staticClass: "margin-bottom-4"
    }, [_c('el-tag', {
      staticClass: "bg-blueFF margin-right-8",
      attrs: {
        "effect": "dark",
        "size": "mini "
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.industry || '') + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', [(_vm.type == 2 && item.year) ? _c('span', {
      staticClass: "city_str"
    }, [_vm._v("#" + _vm._s(item.year || ''))]) : _vm._e(), _vm._v(" "), (item.city_str) ? _c('span', {
      staticClass: "city_str"
    }, [_vm._v("#" + _vm._s(item.city_str || ''))]) : _vm._e(), _vm._v(" "), (item.district_str) ? _c('span', {
      staticClass: "city_str"
    }, [_vm._v("#" + _vm._s(item.district_str))]) : _vm._e()])])], 1)]
  }), _vm._v(" "), (_vm.list.length == 0) ? _c('div', [_c('el-empty', {
    attrs: {
      "description": "暂无数据",
      "image-size": 100
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "menu-btn",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("\n\t\t查看更多"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7e25056"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/recommend.vue
// module id = 910
// module chunks = 1